import React, { useEffect, useState } from 'react'
import { PackageService } from '../../../services';
import { toast } from 'react-toastify';
import { activePlans, addPaymentDetails, createRazorpayOrder, getPackageDetails, paymentVisit } from '../../../asiosConfig';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Card, Chip, Button, Skeleton, Divider } from '@mui/material';
import starBathlehem from "../../../images/Star of Bethlehem.png";
import contact from "../../../images/Contacts.png";
import phoneIcon from "../../../images/phoneAssistIcon.png";
import Guarantee from "../../../images/Guarantee.png";
import defaultIcon from "../../../images/medal.png";
import goldIcon from "../../../images/GoldPackage.png";
import platinumIcon from "../../../images/PlatinumPackage.png";
import diamondIcon from "../../../images/DiamondPackage.png";
import premiumPlusIcon from "../../../images/PremiumPlusPackage.png";
import tillUMarryIcon from "../../../images/TillUMarryPackage.png";
import styled from 'styled-components';

const Container = styled(Box)`
  max-width: 100%;
  margin: auto;
  text-align: center;
  padding: 16px;
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const Header = styled(Box)`
  background: linear-gradient(90deg, #acd9f9 0%, #c2fedb 100%);
  padding: 20px;
  color: white;
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const CardContainer = styled(Card)`
  margin: 16px 0;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const IconButton = styled(Button)`
  background-color: #00c4cc;
  color: white;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
`;

const packageIcons = {
  Gold: goldIcon,
  Platinum: platinumIcon,
  Diamond: diamondIcon,
  Classic: premiumPlusIcon,
  Prime: premiumPlusIcon,
  Royal: tillUMarryIcon,
  Elite: tillUMarryIcon,
};

export const Upgrade = () => {
  const [packageDetails, setPackageDetails] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activePackage, setActivePackage] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = localStorage.getItem('user');

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const data = await getPackageDetails();
        setPackageDetails(data.data.data);
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }
    const fetchActivePlan = async () => {
      try {
        const data = await activePlans();
        setActivePackage(data.data);
        setLoading(false);
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }
    fetchPackageDetails();
    fetchActivePlan();
  }, []);

  const addPaymentView = async (plan) => {
    try {
      await paymentVisit({ ...plan });
    } catch (error) {
      toast.error('Something went wrong')
    }
  }

  const handleRadioChange = (plan) => {
    setSelectedPlan(plan);
  };
  const handlePayment = async () => {
    if (!selectedPlan) {
      toast.error('Please select a package to proceed with payment');
      return;
    }
    
    try {
      // 1. Record visit
      await addPaymentView(selectedPlan);

      // 2. Call Laravel API to create Razorpay order
      const orderPayload = {
        amount: selectedPlan.after_discount_price * 100, // in paise
        notes: {
          plan_id: selectedPlan.package_id,
          user_id: JSON.parse(user)?.id || "anonymous"
        }
      };

      const res = await createRazorpayOrder(orderPayload);

      if (!res.data.success) {
        toast.error('Failed to create Razorpay order');
        return;
      }
      
      const { id: order_id, amount, currency } = res.data.data;
      const razorpayKey = res.data.razorpay_key;

      const options = {
        key: razorpayKey,
        amount: amount,
        currency: currency,
        name: 'Upgrade Membership',
        description: 'Upgrade Membership',
        order_id: order_id,
        handler: async function (response) {
          try {
            const paymentData = {
              package_id: selectedPlan.package_id,
              razorpay_order_id: order_id,
              package_duration_time: selectedPlan.valid_period,
              payment_mode: 'Online',
              payment_status: '1',
              created_date: new Date().toISOString(),
              total_no_days: selectedPlan.valid_period * 30,
              package_amount: selectedPlan.after_discount_price,
              discount_type: selectedPlan?.discount_type,
              discount_value: selectedPlan?.discount_value,
              payment_notes: 'Online',
              razor_pay_id: response.razorpay_payment_id,
              phone_allowed: selectedPlan.phone_number_allowed,
              address_allowed: selectedPlan.phone_number_allowed
            };

            const responses = await addPaymentDetails(paymentData);
            if (responses.status === 200 || responses.status === 201) {
              toast.success('Payment Successful');
              navigate('/success', {
                state: {
                  package: selectedPlan,
                  payment_id: response.razorpay_payment_id,
                }
              });
            } else {
              toast.error(response.data.message);
            }
          } catch (error) {
            toast.error('Something went wrong while recording payment details');
          }
        },
        prefill: {
          name: localStorage.getItem('user_name') || 'John Doe',
          email: localStorage.getItem('email'),
          contact: '1234567890',
        },
        notes: {
          plan_id: selectedPlan.package_id,
        },
        theme: {
          color: '#666666',
        },
        modal: {
          ondismiss: () => {
            navigate('/failed', {
              state: {
                package: selectedPlan,
                payment_id: order_id || 'N/A',
              },
            });
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      toast.error('Something went wrong during payment initialization');
      console.error(error);
    }
  };


  if (loading) {
    return (
      <div className="col-lg-9 col-12">
        <Skeleton variant="text" width="80%" height={40} />
        <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
        <Skeleton variant="text" width="50%" height={30} sx={{ mt: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={100} sx={{ mt: 2 }} />
        <Skeleton variant="text" width="50%" height={30} sx={{ mt: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={100} sx={{ mt: 2 }} />
      </div>
    );
  }

  const isExpired = activePackage?.package_expiry_date
    ? new Date() > new Date(activePackage.package_expiry_date)
    : true;

  const getPlanTitle = (planType) => {
    switch (planType) {
      case 'premium_plan':
        return 'Premium Membership Plan';
      case 'premium_plus_plan':
        return 'Premium Plus Membership Plan';
      case 'assisted':
        return 'Assisted Membership Plan';
      default:
        return planType;
    }
  }

  return (
    <div className="col-lg-9 col-12">
      {activePackage && activePackage.package_name !== "Free" ? (
        isExpired ? (
          <CardContainer>
            <Typography variant="h6" align="center" color="error">
              {activePackage.package_expiry_date
                ? "Your package is expired."
                : "You are currently a Free User."}
            </Typography>
          </CardContainer>
        ) : (
          <CardContainer>
            <Box
              sx={{
                background: "linear-gradient(to right, #b22222, #ff8c00)",
                padding: "16px",
                textAlign: "center",
                color: "white",
              }}
            >
              <Typography variant="h6">
                <img src={starBathlehem} alt="Star Bethlehem" /> Welcome,{" "}
                <strong>{activePackage.name}!</strong> Embrace the Premium Advantage
              </Typography>
            </Box>

            <Box sx={{ padding: "30px" }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ xs: "column", sm: "row" }}
              >
                <Box
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    padding: "0 8px",
                    marginBottom: { xs: "16px", sm: 0 },
                  }}
                >
                  <img src={contact} alt="Contact" />
                  <Typography variant="h6">Contacts</Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    {activePackage.contact_view_count} of {activePackage.phone_allowed} Contacts Viewed
                  </Typography>
                </Box>

                <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "black", display: { xs: "none", sm: "block" } }} />

                <Box
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    padding: "0 8px",
                    marginBottom: { xs: "16px", sm: 0 },
                  }}
                >
                  <img
                    src={packageIcons[activePackage.package_name] || defaultIcon}
                    alt={activePackage.package_name}
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography variant="h6">
                    {activePackage.package_name}
                    <Chip label="Active" color="success" size="small" sx={{ height: "15px" }} />
                  </Typography>
                  <Typography variant="body2">
                    Start Date:{" "}
                    <strong>
                      {new Date(activePackage.created_date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </strong>
                    <br />
                    Expiry:{" "}
                    <strong>
                      {new Date(activePackage.package_expiry_date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </strong>
                  </Typography>
                </Box>

                <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "black", display: { xs: "none", sm: "block" } }} />

                <Box
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    padding: "0 8px",
                    marginBottom: { xs: "16px", sm: 0 },
                  }}
                >
                  <img src={Guarantee} alt="Guarantee" />
                  <Typography variant="h6">Premium Assist</Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    We are Available <br />
                    <img src={phoneIcon} alt="Phone Icon" />
                    From 10 AM - 7 PM
                  </Typography>
                </Box>
              </Box>
            </Box>
          </CardContainer>
        )
      ) : (
        <Typography variant="body1" align="center">
          Upgrade to Premium to enjoy exclusive benefits!
        </Typography>
      )}

      <div className="editProfileBlock">
        <div className="profileDetailsBlock mt-3">
          <div className="basicDetailTlt">
            <p className="text-left">Upgrade Membership</p>
          </div>
          {packageDetails && Object.entries(packageDetails).map(([planType, planData]) => (
            <div key={planType} className="mplan">
              <p className="text-left">
                {getPlanTitle(planType)}
              </p>
              <ul className='text-left'>
                {planData.description.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <div className="durationSec text-left">
                <p className="text-left">Select Duration</p>
                {planData.packages.map((plan, index) => (
                  <div key={index} className="planSec">
                    <div className="d-flex justify-content-between align-items-between planBG">
                      <div className="d-flex align-items-between">
                        <div className="flex-shrink-0">
                          <div className="form-check">
                            <input
                              className="form-check-input radioBtn"
                              type="radio"
                              name="flexRadioDefault"
                              id={`flexRadioDefault${index}`}
                              onChange={() => handleRadioChange(plan)}
                            />
                          </div>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <p className="planname">{plan.package_name.trim()}</p>
                          {plan.discount_type !== 'no discount' && plan.after_discount_price < plan.package_price ? (
                            <>
                              <p className="priceTxt" style={{ textDecoration: 'line-through', color: '#888' }}>
                                Rs. {plan.package_price}
                              </p>

                              {/* Discount Tag Box */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
                                {/* Discount badge */}
                                <p
                                  style={{
                                    display: 'inline-block',
                                    backgroundColor: '#ff102c',
                                    color: '#ffffff',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    margin: 0,
                                  }}
                                >
                                  {plan.discount_type === 'flat'
                                    ? `Flat ₹${parseInt(plan.discount_value)} Off`
                                    : `${parseInt(plan.discount_value)}% Off`}
                                </p>

                                {/* Final discounted price */}
                                <p className="priceTxt" style={{ fontWeight: 'bold', color: '#28a745', margin: 0 }}>
                                  Rs. {plan.after_discount_price}
                                </p>
                              </div>
                            </>
                          ) : (
                            <p className="priceTxt">Rs. {plan.package_price}</p>
                          )}
                        </div>
                      </div>
                      <div>
                        <p className="planname">{plan.valid_period} {plan.valid_period === 1 ? "Month" : "Months"}</p>
                        <p className="priceTxt">
                          {plan.phone_number_allowed !== null
                            ? `${plan.phone_number_allowed} Contact${plan.phone_number_allowed !== 1 ? 's' : ''} To View`
                            : ' '}
                          {plan.opnion
                            ? ` / ${plan.opnion} Opinion`
                            : ''}
                        </p>

                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="d-grid">
          <button className="btn btnBigBg" onClick={handlePayment}>
            PROCEED TO PAY
          </button>
        </div>
      </div>
    </div>
  );
}